import { CloseOutlined } from "@mui/icons-material";
import SettingsIcon from "@mui/icons-material/Settings";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { useState } from "react";
import CustomProductCheckboxGroup from "../../unit/forms/CustomProductCheckboxGroup";

const StateModal = ({ ...props }) => {
  const selected = props?.selected || [];
  const handleChange = (e: any) => {
    if (props?.handleChange) {
      props?.handleChange(e);
    }
  };
  const [open, setOpen] = useState(false);
  return (
    <>
      <IconButton
        onClick={() => setOpen(true)}
        size="large"
        edge="end"
        color="inherit"
        aria-label="menu"
      >
        <SettingsIcon sx={{ color: "#1976d2" }} />
      </IconButton>
      <Dialog
        open={open}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Select States"}
          {/* close icon */}
          <IconButton
            onClick={() => setOpen(false)}
            size="large"
            edge="end"
            color="inherit"
            aria-label="menu"
            sx={{ position: "absolute", right: 18, top: 8 }}
          >
            <CloseOutlined />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <CustomProductCheckboxGroup
            selected={selected}
            handleChange={handleChange}
            optionlist={[
              { id: "AK", label: "Alaska" },
              { id: "AL", label: "Alabama" },
              { id: "AR", label: "Arkansas" },
              { id: "AZ", label: "Arizona" },
              { id: "CA", label: "California" },
              { id: "CO", label: "Colorado" },
              { id: "CT", label: "Connecticut" },
              { id: "DC", label: "District Of Columbia" },
              { id: "DE", label: "Delaware" },
              { id: "FL", label: "Florida" },
              { id: "GA", label: "Georgia" },
              { id: "HI", label: "Hawaii" },
              { id: "IA", label: "Iowa" },
              { id: "ID", label: "Idaho" },
              { id: "IL", label: "Illinois" },
              { id: "IN", label: "Indiana" },
              { id: "KS", label: "Kansas" },
              { id: "KY", label: "Kentucky" },
              { id: "LA", label: "Louisiana" },
              { id: "MA", label: "Massachusetts" },
              { id: "MD", label: "Maryland" },
              { id: "ME", label: "Maine" },
              { id: "MI", label: "Michigan" },
              { id: "MN", label: "Minnesota" },
              { id: "MO", label: "Missouri" },
              { id: "MS", label: "Mississippi" },
              { id: "MT", label: "Montana" },
              { id: "NC", label: "North Carolina" },
              { id: "ND", label: "North Dakota" },
              { id: "NE", label: "Nebraska" },
              { id: "NH", label: "New Hampshire" },
              { id: "NJ", label: "New Jersey" },
              { id: "NM", label: "New Mexico" },
              { id: "NV", label: "Nevada" },
              { id: "NY", label: "New York" },
              { id: "OH", label: "Ohio" },
              { id: "OK", label: "Oklahoma" },
              { id: "OR", label: "Oregon" },
              { id: "PA", label: "Pennsylvania" },
              { id: "RI", label: "Rhode Island" },
              { id: "SC", label: "South Carolina" },
              { id: "SD", label: "South Dakota" },
              { id: "TN", label: "Tennessee" },
              { id: "TX", label: "Texas" },
              { id: "UT", label: "Utah" },
              { id: "VA", label: "Virginia" },
              { id: "VT", label: "Vermont" },
              { id: "WA", label: "Washington" },
              { id: "WI", label: "Wisconsin" },
              { id: "WV", label: "West Virginia" },
              { id: "WY", label: "Wyoming" },
            ]}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default StateModal;
